module.exports = __webpack_public_path__ + "static/media/video-beliefs-en.74510c6e.vtt";